// extracted by mini-css-extract-plugin
module.exports = {"messageWrapper":"NotKiaMessage_messageWrapper__Ps5QN","message":"NotKiaMessage_message__1Hwxg","icon":"NotKiaMessage_icon__0NS3e"};